let timeout_float_cart = false;
let isMouseOverCartIcon = false;
let isMouseOverMiniCart = false;

function show_float_cart(newly_added_product_id = false, type = false) {  
  const float_cart = document.querySelector(".custom-mini-cart");
  if (float_cart) {
    if (timeout_float_cart) {
      clearTimeout(timeout_float_cart);
      timeout_float_cart = false;
    }

    // obtain previous newly added product item.
    const old_cart_newly_added_product = float_cart.querySelector(".custom-cart-product-item-newly");
    if (old_cart_newly_added_product) {
      // remove the CSS class to newly added product item.
      old_cart_newly_added_product.classList.remove("custom-cart-product-item-newly");
    }

    // obtain newly added product item in minicart.
    const cart_newly_added_product = newly_added_product_id
      ? float_cart.querySelector('.custom-cart-product-item[data-cart-product-id="' + newly_added_product_id +'"]')
      : false;

    // check if show a notification (not minicart).
    if ( type == "notification" ||
      (type != "cart" &&
        (document.body.classList.contains("type-cart") ||
          document.body.clientWidth <= 988))
    ) {
      // check if has newly added product in cart.
      if (!cart_newly_added_product) {
        return false;
      }

      // add the CSS class to the minicart to change its appearance.
      float_cart.classList.add("custom-float-cart--notification");
    } else {
      // remove the CSS class from the minicart to display the default appearance.
      float_cart.classList.remove("custom-float-cart--notification");
    }

    // check if has newly added product in cart
    if (cart_newly_added_product) {
      // change the background color of the shopping cart counter in the site header.
      const cart_count_bubble = document.querySelector("header .cart-count-bubble");
      if (cart_count_bubble) {
        cart_count_bubble.style.setProperty("background-color", "#148266");
      }

      // add the CSS class to newly added product item.
      cart_newly_added_product.classList.add("custom-cart-product-item-newly");
    }
    float_cart.classList.add("custom-float-cart--visible");
    checkAndStartTimer();
  }
}

function hide_float_cart() {
  const float_cart = document.querySelector(".custom-float-cart--visible");
  if (float_cart) {
    // clear timer to close automatically.
    if (timeout_float_cart) {
      clearTimeout(timeout_float_cart);
      timeout_float_cart = false;
    }

    // remove the CSS class to show minicart/notification.
    float_cart.classList.remove("custom-float-cart--visible");

    // set default background color of the shopping cart counter in the site header.
    const cart_count_bubble = document.querySelector("header .cart-count-bubble");
    if (cart_count_bubble) {
      cart_count_bubble.style.setProperty("background-color", "");
    }
  }
}

function checkAndStartTimer() {
  if (timeout_float_cart) {
    clearTimeout(timeout_float_cart);
    timeout_float_cart = false;
  }

  if (!isMouseOverCartIcon && !isMouseOverMiniCart) {
    timeout_float_cart = setTimeout(() => {
      hide_float_cart();
    }, 5000);
  }
}

function initMiniCartEvents() {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  const miniCart = document.querySelector(".custom-mini-cart");

  if (cartIcon) {
    cartIcon.addEventListener("mouseenter", () => {
      isMouseOverCartIcon = true;

      if (timeout_float_cart) {
        clearTimeout(timeout_float_cart);
        timeout_float_cart = false;
      }

      if (typeof show_float_cart === "function") {
        show_float_cart();
      }
    });

    cartIcon.addEventListener("mouseleave", () => {
      isMouseOverCartIcon = false;
      checkAndStartTimer();
    });
  }

  if (miniCart) {
    miniCart.addEventListener("mouseenter", () => {
      isMouseOverMiniCart = true;

      if (timeout_float_cart) {
        clearTimeout(timeout_float_cart);
        timeout_float_cart = false;
      }
    });

    miniCart.addEventListener("mouseleave", () => {
      if( isMouseOverMiniCart ){
        isMouseOverMiniCart = false;
        hide_float_cart();
      }else{
        isMouseOverMiniCart = false;
        checkAndStartTimer();
      }
    });
  }
}